import React from 'react';
import { Box } from '@mui/material';

import { SocialCounter } from './social-counter';

export function SocialCounters() {
  return (
    <Box display="flex" justifyContent="center">
      <SocialCounter
        label="TikTok"
        url="https://www.tiktok.com/@matematykagryzie"
        icon={
          <img
            src="assets/social-icons/tiktok.svg"
            alt="Oglądaj rozwiązania zdadań matematycznych na TikToku"
            width="30"
            height="30"
          />
        }
        followers="331k"
      />
      <SocialCounter
        label="Instagram"
        url="https://www.instagram.com/matematykagryzie/"
        icon={
          <img
            src="assets/social-icons/instagram.svg"
            alt="Oglądaj rozwiązania zdadań matematycznych na Instagramie"
            width="30"
            height="30"
          />
        }
        followers="64k"
      />
      <SocialCounter
        label="Facebook"
        url="https://www.facebook.com/matematykagryzie/"
        icon={
          <img
            src="assets/social-icons/facebook.svg"
            alt="Oglądaj rozwiązania zdadań matematycznych na Facebooku"
            width="30"
            height="30"
          />
        }
        followers="6k"
      />
      <SocialCounter
        label="YouTube"
        url="https://www.youtube.com/channel/UCI7QFkkgU5CxmhDTm-6xMag"
        icon={
          <img
            src="assets/social-icons/youtube.svg"
            alt="Oglądaj rozwiązania zdadań matematycznych na YouTubie"
            width="30"
            height="30"
          />
        }
        followers="3.5k"
      />
    </Box>
  );
}

export default SocialCounters;
